/* CAF newsletter band (sections/caf-newsletter.liquid) — theme form → Klaviyo Client Subscriptions API.
   Same list as the Klaviyo embed form in the section setting, so the welcome flow (10% code email) is unchanged.
   Docs: https://developers.klaviyo.com/en/reference/create_client_subscription (202 Accepted, no body). */
(() => {
  const REVISION = '2026-07-15';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const bind = (form) => {
    if (form.dataset.cafNlBound === 'true') return;
    form.dataset.cafNlBound = 'true';

    const root = form.closest('[data-caf-nl]');
    const emailInput = form.querySelector('input[name="email"]');
    const nameInput = form.querySelector('input[name="first_name"]');
    const button = form.querySelector('[data-caf-nl-submit]');
    const errorEl = form.querySelector('[data-caf-nl-error]');
    const done = root && root.querySelector('[data-caf-nl-done]');
    const live = root && root.querySelector('[data-caf-nl-live]');

    const setError = (message) => {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
      emailInput.toggleAttribute('aria-invalid', Boolean(message));
      form.classList.toggle('is-invalid', Boolean(message));
    };

    const setBusy = (busy) => {
      form.classList.toggle('is-busy', busy);
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    };

    emailInput.addEventListener('input', () => {
      if (form.classList.contains('is-invalid') && EMAIL_RE.test(emailInput.value.trim())) setError('');
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (form.classList.contains('is-busy')) return;

      const email = emailInput.value.trim();
      const firstName = nameInput ? nameInput.value.trim() : '';
      if (!EMAIL_RE.test(email)) {
        setError(form.dataset.errorEmail || 'Please enter a valid email address.');
        emailInput.focus();
        return;
      }
      setError('');
      setBusy(true);

      const attributes = {
        email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
      };
      if (firstName) attributes.first_name = firstName;

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || 'Footer signup (theme)',
            profile: { data: { type: 'profile', attributes } },
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.listId } } },
        },
      };

      const url = `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.companyId)}`;
      window
        .fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
          body: JSON.stringify(body),
        })
        .then((response) => {
          if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
          // Tie this browser to the profile (what the Klaviyo form does after a submit). Best effort only.
          try {
            const identity = firstName ? { email, first_name: firstName } : { email };
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(identity);
          } catch (error) {
            /* identify is optional */
          }
          form.hidden = true;
          if (done) {
            done.hidden = false;
            done.focus({ preventScroll: true });
          }
          if (live && done) live.textContent = done.textContent.replace(/\s+/g, ' ').trim();
          document.dispatchEvent(new CustomEvent('caf:newsletter-subscribed', { detail: { source: body.data.attributes.custom_source } }));
        })
        .catch(() => {
          setError(form.dataset.errorGeneric || 'Something went wrong. Please try again in a moment.');
        })
        .finally(() => setBusy(false));
    });
  };

  const init = () => document.querySelectorAll('[data-caf-nl-form]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
